import React from 'react';
import {FlatList, View} from 'react-native';
import {noop} from 'lodash';
import {isNil} from 'lodash';
import {constant, isEmpty} from 'lodash/fp';
import PropTypes from 'prop-types';

import LoadingIndicator from '/component/base/LoadingIndicator';
import PersonFullName from '/component/partial/report/PersonFullName';
import {Footer} from '/component/partial/report/ReportDataProvider/Footer';
import ReportDefaultLoading from '/component/partial/report/ReportDefaultLoading';
import ReportEmptyState from '/component/partial/report/ReportEmptyState';

import {styles} from './OrdersReportDataRenderer.style';
import {OrdersReportListItem} from './OrdersReportListItem';
import {getKeyExtractor} from './OrdersReportListItem.util';

export function getRenderItem({
  alternateItemKey,
  personIsCoach,
  PersonNameComponent,
  PersonRoleComponent,
  PersonInfoComponent,
  NewLabelComponent,
  reportName,
  onRecordPress,
  hasHorizontalPadding,
}: any) {
  return ({item, index}: any) => {
    return (
      <OrdersReportListItem
        alternateItemKey={alternateItemKey}
        personIsCoach={personIsCoach}
        PersonNameComponent={PersonNameComponent}
        PersonRoleComponent={PersonRoleComponent}
        PersonInfoComponent={PersonInfoComponent}
        NewLabelComponent={NewLabelComponent}
        reportName={reportName}
        onRecordPress={onRecordPress}
        item={item}
        index={index}
        hasHorizontalPadding={hasHorizontalPadding}
        isPeopleToContactSection={true}
      />
    );
  };
}

class OrdersReportDataRenderer extends React.PureComponent {
  // @ts-expect-error TS(4114): This member must have an 'override' modifier becau... Remove this comment to see the full error message
  componentDidMount() {
    // @ts-expect-error TS(2339): Property 'fetchReport' does not exist on type 'Rea... Remove this comment to see the full error message
    const {fetchReport, loadingData} = this.props;
    setTimeout(function () {
      fetchReport(loadingData.reportHeading);
    }, 500);
  }

  // @ts-expect-error TS(4114): This member must have an 'override' modifier becau... Remove this comment to see the full error message
  componentDidUpdate(prevProps: any) {
    const {hasReportData: hadReportData} = prevProps;
    // @ts-expect-error TS(2339): Property 'hasReportData' does not exist on type 'R... Remove this comment to see the full error message
    const {hasReportData, fetchUpdatedReport, loadingData} = this.props;
    if (hadReportData && !hasReportData) {
      setTimeout(function () {
        fetchUpdatedReport(loadingData.reportHeading);
      }, 500);
    }
  }

  // @ts-expect-error TS(4114): This member must have an 'override' modifier becau... Remove this comment to see the full error message
  render() {
    const {
      // @ts-expect-error TS(2339): Property 'alternateItemKey' does not exist on type... Remove this comment to see the full error message
      alternateItemKey,
      // @ts-expect-error TS(2339): Property 'reportIsLoading' does not exist on type ... Remove this comment to see the full error message
      reportIsLoading,
      // @ts-expect-error TS(2339): Property 'reportData' does not exist on type 'Read... Remove this comment to see the full error message
      reportData,
      // @ts-expect-error TS(2339): Property 'hasReportData' does not exist on type 'R... Remove this comment to see the full error message
      hasReportData,
      // @ts-expect-error TS(2339): Property 'reportName' does not exist on type 'Read... Remove this comment to see the full error message
      reportName,
      // @ts-expect-error TS(2339): Property 'clientMilestone' does not exist on type ... Remove this comment to see the full error message
      clientMilestone,
      // @ts-expect-error TS(2339): Property 'loadingComponent' does not exist on type... Remove this comment to see the full error message
      loadingComponent: LoadingComponent,
      // @ts-expect-error TS(2339): Property 'personNameComponent' does not exist on t... Remove this comment to see the full error message
      personNameComponent: PersonNameComponent,
      // @ts-expect-error TS(2339): Property 'personRoleComponent' does not exist on t... Remove this comment to see the full error message
      personRoleComponent: PersonRoleComponent,
      // @ts-expect-error TS(2339): Property 'personInfoComponent' does not exist on t... Remove this comment to see the full error message
      personInfoComponent: PersonInfoComponent,
      // @ts-expect-error TS(2339): Property 'NewLabelComponent' does not exist on typ... Remove this comment to see the full error message
      NewLabelComponent: NewLabelComponent,
      // @ts-expect-error TS(2339): Property 'loadingData' does not exist on type 'Rea... Remove this comment to see the full error message
      loadingData,
      // @ts-expect-error TS(2339): Property 'personIsCoach' does not exist on type 'R... Remove this comment to see the full error message
      personIsCoach,
      // @ts-expect-error TS(2339): Property 'onRecordPress' does not exist on type 'R... Remove this comment to see the full error message
      onRecordPress,
      // @ts-expect-error TS(2339): Property 'fetchMoreReport' does not exist on type ... Remove this comment to see the full error message
      fetchMoreReport,
      // @ts-expect-error TS(2339): Property 'reportMeta' does not exist on type 'Read... Remove this comment to see the full error message
      reportMeta,
    } = this.props;
    if (!hasReportData && reportIsLoading) {
      if (!isNil(loadingData)) {
        return <ReportDefaultLoading {...loadingData} />;
      }
      return (
        // @ts-expect-error TS(2339): Property 'loading' does not exist on type '{ base:... Remove this comment to see the full error message
        <View style={styles.loading}>
          <LoadingIndicator size="large" style={styles.loadingIndicator} />
        </View>
      );
    }
    return (
      <View style={styles.base}>
        {!isEmpty(reportData) ? (
          <FlatList
            onEndReachedThreshold={0.5}
            initialNumToRender={10}
            scrollIndicatorInsets={styles.scrollIndicatorInsets}
            viewabilityConfig={{
              viewAreaCoveragePercentThreshold: 95,
            }}
            data={reportData}
            keyExtractor={getKeyExtractor({alternateItemKey})}
            renderItem={getRenderItem({
              alternateItemKey,
              personIsCoach,
              PersonNameComponent,
              PersonRoleComponent,
              PersonInfoComponent,
              NewLabelComponent,
              reportName,
              clientMilestone,
              onRecordPress,
              hasHorizontalPadding: true,
            })}
            onEndReached={fetchMoreReport}
            ListFooterComponent={
              <Footer
                reportMeta={reportMeta}
                loadingData={loadingData}
                reportData={reportData}
                reportIsLoading={reportIsLoading}
                loadingComponent={LoadingComponent}
              />
            }
          />
        ) : (
          <ReportEmptyState />
        )}
      </View>
    );
  }
}

// @ts-expect-error TS(2339): Property 'propTypes' does not exist on type 'typeo... Remove this comment to see the full error message
OrdersReportDataRenderer.propTypes = {
  alternateItemKey: PropTypes.string,
  reportData: PropTypes.any,
  hasReportData: PropTypes.bool,
  reportIsLoading: PropTypes.bool,
  reportName: PropTypes.string,
  clientMilestone: PropTypes.string,
  loadingData: PropTypes.object,
  fetchReport: PropTypes.func,
  fetchUpdatedReport: PropTypes.func,
  personNameComponent: PropTypes.elementType,
  personRoleComponent: PropTypes.elementType,
  personInfoComponent: PropTypes.elementType,
  NewLabelComponent: PropTypes.elementType,
  loadingComponent: PropTypes.elementType,
  personIsCoach: PropTypes.func,
  onRecordPress: PropTypes.func,
  fetchMoreReport: PropTypes.func,
  reportMeta: PropTypes.any,
  reportHeading: PropTypes.string,
};

// @ts-expect-error TS(2339): Property 'defaultProps' does not exist on type 'ty... Remove this comment to see the full error message
OrdersReportDataRenderer.defaultProps = {
  alternateItemKey: null,
  reportData: null,
  hasReportData: false,
  reportIsLoading: true,
  reportName: '',
  clientMilestone: '',
  loadingData: {},
  personNameComponent: PersonFullName,
  personRoleComponent: constant(null),
  personInfoComponent: constant(null),
  NewLabelComponent: null,
  loadingComponent: null,
  personIsCoach: constant(false),
  fetchReport: noop,
  fetchUpdatedReport: noop,
  onRecordPress: noop,
  fetchMoreReport: noop,
  reportMeta: null,
  reportHeading: '',
};

export default OrdersReportDataRenderer;
